import { render, staticRenderFns } from "./RoomCBT.vue?vue&type=template&id=0e8813bc&"
import script from "./RoomCBT.vue?vue&type=script&lang=js&"
export * from "./RoomCBT.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0e8813bc')) {
      api.createRecord('0e8813bc', component.options)
    } else {
      api.reload('0e8813bc', component.options)
    }
    module.hot.accept("./RoomCBT.vue?vue&type=template&id=0e8813bc&", function () {
      api.rerender('0e8813bc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Room/CBT/RoomCBT.vue"
export default component.exports